
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, Outlet, useParams, useLocation } from "react-router-dom";
import logoutLogo from '../../assets/logout.png';


import tanoEdLogo from '../../assets/logoTanoEd.png';
import { useClasseContext } from "../../context/ClasseContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { url } from '../../utils/confserveur';
import SideBarChef from "./SideBarChef";
import { useUser } from "../../context/UserContext";
import SideBarProfCordo from "./SideBarProfCordo";
import SideBarProf from "./SideBarProf";
import { fetchSchoolHolidays } from "../../utils/vacances";
import Cookies from 'js-cookie';
import { X, Menu, Building } from "lucide-react";
import TopBar from "./TopBar";
import useArriveeChangerDeClasse from "../../hooks/ui/useArriveeChangerDeClasse";
function Sidebar() {

 

    const params = useParams();
    const idclasse = params.idclasse;
    const [classeSelection, setClasseSelection] = useState('');
    const {classeNom, groupNom, setClasseNom , setGroupNom, setClassesGroup,
       nomProf, setNiveauEvalnat, logout, ActivePeriode, setActivePeriode} = useClasseContext();
    const [reload, setReload] = useState(false)

    const { user, isAuthenticated, loading, init,fetchUserData,setIsAuthenticated, etablissementLoading,etablissementData, fetchEtablissementData, selectedEtablissementId } = useUser();

    const role = user && user.role;
    const iduser = user && user.id;
const [showScrollButton, setShowScrollButton] = useState(false);
const lastScrollYRef = useRef(0);
      // Ajouter ces états au début de votre composant
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [isMobile, setIsMobile] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [periode,setPeriode] = useState([])

    const navigate = useNavigate();
 // Fonction debounce pour éviter trop d'appels lors du resize
 useEffect(() => {
  
        async function getVacances() {
          // Appelle la fonction fetchSchoolHolidays qui renvoie un objet avec { vacances, periode }
          const {vacances, periode } = await fetchSchoolHolidays();
          // Mets à jour ton état avec les vacances récupérées
        
          
          setPeriode(periode)  
        
          if (periode && periode.length > 0) {
            const date_debut = periode[0].date_debut;
            const date_fin = periode[periode.length - 1].date_fin;
      
            setActivePeriode({
              type_periode: 'Annuel',
              date_debut,
              date_fin
            });
          }
          else {
            // Aucun retour, on définit notre propre période par défaut.
            const today = new Date();
            const currentYear = today.getFullYear();
            const augustFirstCurrent = new Date(currentYear, 7, 1); // 7 = août (0-indexé)
            
            let defaultStart;
            // Si aujourd'hui est après ou égal au 1er août de l'année en cours
            if (today >= augustFirstCurrent) {
              defaultStart = augustFirstCurrent;
            } else {
              // Sinon, le début est le 1er août de l'année précédente
              defaultStart = new Date(currentYear - 1, 7, 1);
            }
            
            // La date de fin est le 1er août de l'année suivant le début
            const defaultEnd = new Date(defaultStart.getFullYear() + 1, 7, 1);
            
            // Formatage des dates en "YYYY-MM-DD" (adaptable selon vos besoins)
            const formatDate = (date) => date.toISOString().split('T')[0];
            
            setActivePeriode({
              type_periode: 'Annuel',
              date_debut: formatDate(defaultStart),
              date_fin: formatDate(defaultEnd)
            });
          }
        }
        getVacances();
      }, [setActivePeriode]);

useEffect(() => {
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const lastScrollY = lastScrollYRef.current;

    if (window.innerWidth < 1280) { // 1280px = xl breakpoint
      if (currentScrollY > 100 && currentScrollY > lastScrollY && !isSidebarOpen) {
        setShowScrollButton(true);
      }
      else if (currentScrollY < lastScrollY || isSidebarOpen) {
        setShowScrollButton(false);
      }
    } else {
      setShowScrollButton(false);
    }

    lastScrollYRef.current = currentScrollY;
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, [isSidebarOpen]);
    
  const anneescolaire = useMemo(() => {
    if (periode && periode.length > 0) {
      const date_debut = periode[0].date_debut;
      const date_fin = periode[periode.length - 1].date_fin;
  
      return {
        type_periode: 'Annuel',
        date_debut,
        date_fin
      };
    }
    else {
      // Aucun retour de l'API, on définit une période par défaut.
      const today = new Date();
      const currentYear = today.getFullYear();
      const augustFirstCurrent = new Date(currentYear, 7, 1); // 7 = août (0-indexé)
      
      let defaultStart;
      // Si aujourd'hui est postérieur ou égal au 1er août de l'année en cours
      if (today >= augustFirstCurrent) {
        defaultStart = augustFirstCurrent;
      } else {
        // Sinon, le début est fixé au 1er août de l'année précédente
        defaultStart = new Date(currentYear - 1, 7, 1);
      }
      
      // La date de fin est le 1er août de l'année suivant la date de début
      const defaultEnd = new Date(defaultStart.getFullYear() + 1, 7, 1);
      
      // Fonction de formatage en "YYYY-MM-DD"
      const formatDate = (date) => date.toISOString().split('T')[0];
      
      return {
        type_periode: 'Annuel',
        date_debut: formatDate(defaultStart),
        date_fin: formatDate(defaultEnd)
      };
    }
  }, [periode]);

useEffect( ()=>{
  
})
// 1️⃣ NOUVEAU : Charger les données utilisateur au montage du Sidebar
useEffect(() => {
  const initializeUserData = async () => {
    // Si on a déjà un user ET isAuthenticated, pas besoin de refetch
    if (user && isAuthenticated) return;

    // Si on n'a pas encore vérifié l'auth, le faire maintenant
      const isAuth = await fetchUserData();
      // Si pas authentifié, on sera redirigé par l'autre useEffect
      if (!isAuth) {
        init();
        navigate('/');
        return;
      }

  };

  initializeUserData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // Une seule fois au montage

// 2️⃣ useEffect principal pour la validation de session
useEffect(() => {
  // Si plusieurs établissements et aucun sélectionné
  if (
    user?.etablissements?.length > 1 &&
    !selectedEtablissementId &&
    !localStorage.getItem('etablissement_id')
  ) {
    navigate('/home/choix-etablissement');
    return;
  }
}, [loading, isAuthenticated, etablissementData, user, selectedEtablissementId, navigate, init]);

//3️⃣ useEffect pour charger les données établissement
useEffect(() => {
  // Ne charger que si toutes les conditions sont réunies

  if (
    !loading &&
    isAuthenticated &&
    selectedEtablissementId &&
    !etablissementData &&
    !etablissementLoading
  ) {
    fetchEtablissementData(false);
  }
}, [loading, isAuthenticated, selectedEtablissementId, etablissementData, etablissementLoading, fetchEtablissementData]);

// 4️⃣ useEffect pour gérer le refresh forcé
useEffect(() => {
  if (reload && selectedEtablissementId) {
    fetchEtablissementData(true);
    setReload(false);
  }
}, [reload, selectedEtablissementId, fetchEtablissementData]);



// Vérifier la validité de la connexion et charger les données d'établissement si nécessaire
useEffect(() => {
  if(isAuthenticated && etablissementData && (classeNom||groupNom)){
  
    if (localStorage.getItem('classeActive') && etablissementData?.classes) {
      const classeFound = etablissementData.classes.find((classe) => classe.id === parseInt(idclasse,10));
     
      if (classeFound && classeFound.nom !== classeNom) {
        handleLogout();
      }
    }
    else if (localStorage.getItem('groupeActive') && etablissementData?.groupes) {
      const groupeFound = etablissementData.groupes.find((groupe) => groupe.id === parseInt(idclasse,10));
      if (groupeFound && groupeFound.nom !== groupNom) {
        handleLogout();
      }
    }
  }
  }, [classeNom, etablissementData, groupNom, idclasse,isAuthenticated]);

  // AJOUTER APRÈS les autres useEffect :
useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth < 1280); // xl breakpoint
  };
  
  checkMobile();
  window.addEventListener('resize', checkMobile);
  return () => window.removeEventListener('resize', checkMobile);
}, []);

    const handleLogout = (event) => {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
  
      (async () => {
          try {
              // Appelle l'API de déconnexion
              const csrfToken = Cookies.get('csrftoken');
              await axios.post(
                  `${url}logout/`,
                  {}, // Aucun corps nécessaire
                  { withCredentials: true ,
                     headers: {
            'X-CSRFToken': csrfToken, // <-- ici
          },
                  } // Inclut les cookies sécurisés
              );
                 
              // Réinitialise l'état et redirige vers la page de connexion
              logout(); // Appelle une fonction locale pour réinitialiser l'état utilisateur
              init(); // Fonction init le context.
              navigate('/');
               // 🔥 NETTOYER TOUT LE LOCALSTORAGE
          localStorage.clear(); // Supprime TOUT
              window.location.reload();

          } catch (error) {
              console.error('Erreur lors de la déconnexion :', error);
          }
      })();
  };
  // 1. Ajouter la fonction handleLinkClick
const handleLinkClick = () => {
  if (isMobile) {
    setIsSidebarOpen(false);
  }
};
  const handleHomeClick = () => {
    setClasseSelection(false);
    setNiveauEvalnat(null)
    localStorage.setItem('classeActive', '')
    localStorage.setItem('groupeActive','')
    setGroupNom("")
    setActivePeriode(anneescolaire)
    setClasseNom("")
    setClassesGroup([])
    setReload(true)
    handleLinkClick()
  }
  // « Changer de classe » : la classe se vide à l'arrivée sur l'accueil, plus
  // au clic (une saisie de notes non sauvegardée peut retenir la navigation).
  useArriveeChangerDeClasse(handleHomeClick);
 // Projection QCM : plein écran sans sidebar. Composition d'une session
 // (/home/qcm/<id>, pas ses sous-routes live/projection/resultats) : idem —
 // le panneau des attendus et les cartes d'exerciseurs ont besoin de toute
 // la largeur, l'écran porte son propre bouton de retour à la classe
 // (chantier composition, 2026-09-02). Le QCM de suivi de l'évaluation
 // nationale (/home/eval-bilan/<id>) se compose de la même façon (2026-10-11),
 // mais le détail d'un QCM de suivi déjà créé (?bilan=<id>, ouvert depuis
 // Évaluations) n'est pas une composition : il garde la sidebar.
 const location = useLocation();
 const isProjection = location.pathname.includes('/projection');
 const isComposition = /^\/home\/(qcm|eval-bilan)\/\d+\/?$/.test(location.pathname)
   && !(location.pathname.startsWith('/home/eval-bilan/') && new URLSearchParams(location.search).has('bilan'));
 if (isComposition) {
   return (
     <div className="w-full flex flex-col relative min-h-screen text-black">
       {/* Quatre plans (2026-09-03) : barre du haut gris très clair, en-tête
           de contexte bleu glacier, espace de travail bleu clair uni (un peu
           moins saturé que le dégradé de l'application), cartes blanches.
           Le body est sombre : sans ce fond, l'écran sortait noir. Un fond
           neutre a été essayé le 2026-09-02 : trop blanc. */}
       <div className="fixed inset-0 pointer-events-none bg-[#E8F5FF]" />
       {role && iduser && etablissementData && <TopBar sobre />}
       <div className="relative w-full flex-1">
         {(role && iduser && (etablissementData || (user && user.etablissements && user.etablissements.length > 1))) && <Outlet />}
       </div>
     </div>
   );
 }
 if (isProjection) {
   return (
     <div className="w-full min-h-screen">
       {(role && iduser && (etablissementData || (user && user.etablissements && user.etablissements.length > 1))) && <Outlet />}
     </div>
   );
 }

 // Pour les élèves, on affiche directement le contenu sans sidebar
 if (role === "eleve") {
   return (
     <div className="w-full min-h-screen">
       {(role && iduser && (etablissementData || (user && user.etablissements && user.etablissements.length > 1))) && <Outlet />}
     </div>
   );
 }

 return (
       <>
       {/* Bouton Menu Burger */}
    <button
      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      className="xl:hidden fixed top-4 left-4 z-50 p-2 bg-blue-600 text-white rounded-lg shadow-lg"
    >
      {isSidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
    </button>

   {/* Bouton Menu Burger flottant au scroll */}
{showScrollButton && !isSidebarOpen && (
  <button
    onClick={() => setIsSidebarOpen(true)}
    className="xl:hidden fixed bottom-6 right-6 z-50 p-3 bg-blue-600 text-white rounded-full shadow-lg animate-bounce"
  >
    <Menu className="w-6 h-6" />
  </button>
)}
{/* Overlay pour mobile - AJOUTER CECI APRÈS LE BOUTON FLOTTANT */}
{isSidebarOpen && (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 z-30 xl:hidden"
    onClick={() => setIsSidebarOpen(false)}
  />
)}

    {/* Modifier votre aside existant */}
 <aside className={`
  fixed h-full overflow-auto shadow-lg z-40
  transition-transform duration-300 ease-in-out
  w-72
  ${!isSidebarOpen ? '-translate-x-full' : 'translate-x-0'}
  xl:translate-x-0
`}>
         {/* Modifier le spacer - visible seulement sur desktop */}

          <div className="sidebar-modern flex flex-col   rounded dark:bg-gray-900 min-h-screen
          3xl:text-3xl " style={{
            background: `
              radial-gradient(ellipse at -50% 28%, #068aff, transparent 80%),
              #001a33
            `
          }}>
        {(role === "professeur" && etablissementData) &&
            <div className=" flex-grow  ">
                {/* Titre de présentation */}
        
            
            {/* Brand header — typographie Inter (design Tanoed) */}
            <div className="px-5 pt-5 pb-4 flex items-center gap-3">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center backdrop-blur-sm shrink-0 bg-white/15">
                <img src={tanoEdLogo} alt="logo" className="w-10 h-10" />
              </div>
              <div className="min-w-0 flex-1 leading-tight">
                <div className="text-[15px] font-semibold text-white">Espace professeur</div>
                <div className="text-[12px] text-blue-200/80 truncate mt-0.5">
                  {etablissementData?.professeurs.find(prof => prof.id === user.id)?.nom}{' '}
                  {etablissementData?.professeurs.find(prof => prof.id === user.id)?.prenom}
                </div>
                {/* Badges Coordo / Délégué — compactes */}
                <div className="mt-1 flex items-center gap-1 flex-wrap">
                  {etablissementData?.professeurs.find(prof => prof.id === user.id)?.coordonateur && (
                    <span className="inline-flex items-center gap-0.5 px-1 py-px rounded bg-emerald-500/15 text-emerald-300 text-[9px] font-semibold leading-none">
                      <span className="w-1 h-1 rounded-full bg-emerald-400" />
                      Coordo
                    </span>
                  )}
                  {etablissementData?.professeurs.find(prof => prof.id === user.id)?.delegue_affectation && (
                    <span className="inline-flex items-center px-1 py-px rounded bg-amber-500/15 text-amber-300 text-[9px] font-semibold leading-none">
                      Délégué
                    </span>
                  )}
                </div>
              </div>
            </div>
          {/* Établissement — pill compacte adaptée au fond bleu */}
          <div className="mx-5 mb-3 flex items-center gap-2 px-3 py-2 rounded-xl bg-white/10 border border-white/10 backdrop-blur-sm">
            <Building className="w-4 h-4 text-blue-200/70 shrink-0" />
            <span className="text-[12px] text-white/90 truncate">{etablissementData?.nom}</span>
          </div>
            <ul className="">
              {/* Affichage si classe pas sélectionné. */}
             {!classeSelection && !idclasse ? (() => {
                const prof = etablissementData?.professeurs?.find(p => p.id === iduser);
                const isCordo = prof?.coordonateur;
                const isDelegue = prof?.delegue_affectation;
                return <>
                  {/* Menu établissement : visible par le coordo ET le délégué.
                      Seul l'onglet « Résultats nationaux » du Pilotage est réservé
                      au délégué (cf. PilotageCoordoTabs). */}
                  {(isCordo || isDelegue) &&
                    <SideBarProfCordo handleHomeClick={handleHomeClick} />
                  }
                </>;
              })()
             :
    <SideBarProf periode={periode} anneescolaire={anneescolaire} />
      }
            
              </ul>

                </div> 
}

{role ==="chef" &&  <div className=" flex-grow"> <SideBarChef handleHomeClick={handleHomeClick} periode={periode} anneescolaire={anneescolaire} /> </div>  }

            {/* Footer — adapté au fond bleu Tanoed (translucide blanc) */}
            <div className="px-4 pb-4 pt-3 border-t border-white/10 mt-2">
              {etablissementData && !etablissementData.is_gar && (
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl bg-white/10 hover:bg-white/15 text-white/90 text-[13px] font-medium transition-all backdrop-blur-sm"
                >
                  <img src={logoutLogo} alt="" className="w-4 h-4 opacity-80" />
                  Déconnexion
                </button>
              )}
              <div className="mt-3 flex items-center justify-center gap-3 text-[11px] text-blue-200/60">
                <Link to="/mentions" className="hover:text-white/90 transition-colors">Mentions légales</Link>
                <span>·</span>
                <Link to="/rgpd" className="hover:text-white/90 transition-colors">RGPD</Link>
                <span>·</span>
                <Link to="/cgu" className="hover:text-white/90 transition-colors">CGU</Link>
              </div>
              <div className="mt-2 text-center text-[10px] text-blue-200/40">
                &copy; SAS Tanoed - 935059899
              </div>
            </div>
            {/* ...rest of the sidebar content */}

        
          </div>
        </aside>
   {/* min-w-0 (12/10/2026) : ce bloc est un élément flex (App.js, <div className="flex">) ; sans min-w-0, il ne
       descend jamais sous la largeur de son contenu, et un tableau large (31 questions) élargissait toute la page au
       lieu de défiler dans sa zone : barre de défilement horizontale de page, onglets coupés à droite. w-full reste :
       sans lui, le bloc se réduit à la largeur de son contenu (essayé le même jour : un grand vide à droite). */}
   <div className="w-full min-w-0 flex flex-col h-full relative min-h-screen text-black xl:ml-72">
       {/* Fond gaming glassmorphism clair */}
       <div className="fixed inset-0 xl:left-72 pointer-events-none">
         <div className="absolute inset-0 bg-gradient-to-br from-blue-100 via-sky-100 to-blue-200" />
         <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-gradient-to-br from-cyan-300/30 to-blue-400/20 rounded-full blur-[120px]" />
         <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-gradient-to-tl from-sky-300/25 to-cyan-300/15 rounded-full blur-[140px]" />
         <div className="absolute top-1/2 left-1/3 w-[400px] h-[400px] bg-gradient-to-r from-teal-300/20 to-emerald-300/15 rounded-full blur-[100px]" />
         <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] bg-gradient-to-bl from-blue-300/20 to-violet-300/15 rounded-full blur-[80px]" />
       </div>
       {role && iduser && etablissementData && <TopBar />}
       <div className="relative w-full flex-1 text-3xl ">

       {(role && iduser && (etablissementData || (user && user.etablissements && user.etablissements.length > 1 ))) && <Outlet /> }

        </div>

        </div>
        </>
      );
    }

export default Sidebar;